import IconLoader from "@/features/Common/components/IconLoader";
import WellnessCategoryCard from ".";
import { Button, Stack } from "@mui/material";
import {
  WellnessCategoryCardProps,
  WellnessScoreStatus,
} from "../Common/types";

const exampleProps: WellnessCategoryCardProps = {
  icon: (
    <IconLoader
      icon="HealthHistoryIcon"
      color="primary"
      sx={{ fontSize: 40 }}
    />
  ),
  title: "Health Check",
  status: WellnessScoreStatus.Incomplete,
  description:
    "lorem ipsum dolor sit amet consectetur adipiscing elit. Lorem ipsum dolor sit amet consectetur adipiscing elit. Lorem ipsum dolor sit amet consectetur ",
  lastUpdated: "2022-01-01",
};

export default function WellnessCategoryCardExamples() {
  return (
    <WellnessCategoryCard {...exampleProps}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => console.log("Primary Button Clicked")}
        fullWidth
      >
        {"Primary Button"}
      </Button>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => console.log("Secondary Button Clicked")}
        fullWidth
      >
        {"Secondary Button"}
      </Button>
    </WellnessCategoryCard>
  );
}
